import { Type } from '@sinclair/typebox';
import { AttributeValueSingleSchema } from "./shared.mjs";
export const AttributeValueResponseSchema = Type.Object({
    id: Type.Number(),
    versionId: Type.Number(),
    attributeId: Type.Number(),
    value: AttributeValueSingleSchema,
});
export const CreateAttributeValueSchema = Type.Omit(AttributeValueResponseSchema, ['id']);
export const UpdateAttributeValueSchema = Type.Partial(Type.Omit(CreateAttributeValueSchema, ['versionId']));
//# sourceMappingURL=attribute-values.js.map